import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, TrendingUp, Wallet, Target, Building2, Boxes,
  Lock, HardHat, Sparkles, Globe2, MessageSquare, Settings as SettingsIcon, ChevronLeft, ChevronRight,
} from "lucide-react";
import { Logo } from "./Logo";

const NAV = [
  { to: "/", icon: LayoutDashboard, label: "Command Center" },
  { to: "/sales", icon: TrendingUp, label: "Sales Intelligence" },
  { to: "/collection", icon: Wallet, label: "Collection Intelligence" },
  { to: "/targets", icon: Target, label: "Target vs Achievement" },
  { to: "/projects", icon: Building2, label: "Project Intelligence" },
  { to: "/inventory", icon: Boxes, label: "Inventory Intelligence" },
  { to: "/blocked", icon: Lock, label: "Blocked Units" },
  { to: "/engineering", icon: HardHat, label: "Engineering Milestone" },
  { to: "/strategic", icon: Sparkles, label: "Strategic Insights" },
  { to: "/market", icon: Globe2, label: "Market Intelligence" },
  { to: "/vexen-ai", icon: MessageSquare, label: "Vexen AI", accent: true },
  { to: "/settings", icon: SettingsIcon, label: "Settings" },
];

export const Sidebar = ({ collapsed, onToggle }) => {
  return (
    <aside
      className="vexen-sidebar hidden md:flex flex-col fixed left-0 top-0 bottom-0 z-30 transition-all duration-300"
      style={{ width: collapsed ? 80 : 264 }}
      data-testid="sidebar"
    >
      <div className="flex items-center justify-between px-5 py-5 border-b border-white/5">
        {collapsed ? <Logo size={36} withText={false} /> : <Logo size={36} withText lightWordmark />}
        <button
          onClick={onToggle}
          className="text-slate-400 hover:text-white p-1 rounded"
          data-testid="sidebar-toggle"
        >
          {collapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </button>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto scroll-thin">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) =>
              `vexen-sidebar-item ${isActive ? "active" : ""} ${item.accent && !isActive ? "text-gold" : ""}`
            }
            data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <item.icon size={18} strokeWidth={1.7} />
            {!collapsed && <span className="truncate">{item.label}</span>}
          </NavLink>
        ))}
      </nav>
      <div className="px-5 py-4 border-t border-white/5 text-[10px] uppercase tracking-[0.2em] text-slate-500 font-mono">
        {!collapsed ? "© Scitus.ai" : "©"}
      </div>
    </aside>
  );
};
